import React, { createContext, useContext, ReactNode } from 'react'

interface SocialMediaLink {
  id?: string
  platform: 'linkedin' | 'facebook' | 'instagram' | 'twitter' | 'tiktok' | 'youtube' | 'website'
  url: string
  username?: string
  displayName?: string
}

interface TeamContextData {
  teamId?: string
  teamSlug?: string
  teamSubdomain?: string
  teamName?: string
  teamLogoUrl?: string
  companyName?: string
  teamStyle?: {
    backgroundColor?: string
    headerColor?: string
    backgroundPosition?: string
    backgroundTiled?: boolean
    backgroundImageUrl?: string | null
    hasBackgroundImage?: boolean
  }
  socialMediaLinks?: SocialMediaLink[]
  homePageOptions?: {
    tabAlignment?: 'left' | 'center' | 'right'
    navigationLayout?: 'vertical' | 'horizontal'
    navbarName?: string
    customCss?: string
    showHero?: boolean
    heroTitle?: string;
    heroSubtitle?: string;
    heroCtaText?: string;
    heroCtaLink?: string;
    heroBackgroundType?: string;
    heroBackgroundColor?: string;
    heroGradientStartColor?: string;
    heroGradientEndColor?: string;
    heroGradientDirection?: string;
    heroFontFamily?: string;
    heroTextColor?: string;
    heroButtonBgColor?: string;
    heroButtonTextColor?: string;
    heroOverlayOpacity?: number;
    heroSecondaryCtaText?: string;
    heroSecondaryCtaLink?: string;
    heroSecondaryButtonBgColor?: string;
    heroSecondaryButtonTextColor?: string;
    heroSecondaryButtonBorderColor?: string;
    showHeroSecondaryCta?: boolean;
    heroDetailsBackgroundCard?: boolean;
    heroDetailsCardBackgroundColor?: string;
    heroDetailsCardOpacity?: number;
    overlayType?: string;
    overlayColor?: string;
    overlayGradientStart?: string;
    overlayGradientEnd?: string;
    overlayGradientDirection?: string;
    heroBackgroundImageUrl?: string;
  }
}

const TeamContext = createContext<TeamContextData | undefined>(undefined)

interface TeamProviderProps {
  children: ReactNode
  teamData: TeamContextData
}

export const TeamProvider: React.FC<TeamProviderProps> = ({ children, teamData }) => {
  return (
    <TeamContext.Provider value={teamData}>
      {children}
    </TeamContext.Provider>
  )
}

export const useTeamContext = () => {
  const context = useContext(TeamContext)
  if (!context) {
    throw new Error('useTeamContext must be used within a TeamProvider')
  }
  return context
}